module.exports = __webpack_public_path__ + "app/community/list-companies-community-1-xYHA64.html";